<template>
  <div
    class="sticky-base-panel"
    ref="refRoot"
  >
    <div class="wrap">
      <BlockTransition
        :animateIn="animateInBg"
        :trigger="trigger"
      />
      <div
        class="the-container"
        ref="refInner"
      >
        <div class="the-grid">
          <div class="the-col">
            <div
              class="preheading type-mono"
              ref="refPreheading"
            >
              {{ preheading }}
            </div>
            <h2 class="heading type-h2">
              <AnimatedTextByWord
                :auto="false"
                ref="refHeading"
                @loaded="onLoaded"
              >
                {{ heading }}
              </AnimatedTextByWord>
            </h2>
          </div>
        </div>
      </div>

      <div
        class="the-container logo-container"
        v-show="showLogo"
      >
        <div class="the-grid">
          <div class="logo-col">
            <img
              class="logo"
              src="@/icons/logo_stroke.svg?inline"
              ref="refLogo"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
// import LogoStroke from "@/icons/logo_stroke.svg?component"

const props = defineProps({
  preheading: {},
  heading: {},
  trigger: {}, // the trigger element
  animateInBg: {
    default: false,
  },
  showLogo: {
    default: false,
  },
})

const emits = defineEmits([])

const { $gsap, $ScrollTrigger } = useNuxtApp()

const { app, debug, browser } = useStores()

const env = useEnv()

const refRoot = ref(null)
const refInner = ref(null)
const refPreheading = ref(null)
const refHeading = ref(null)
const refLogo = ref(null)

const { init: initIn } = useScrollTrigger(() => {
  let tl = $gsap.timeline({
    scrollTrigger: {
      id: "sticky-base-panel",
      trigger: props.trigger,
      start: () => `top center-=${browser.lvh * 0.333333}`,
      end: () => `top+=${browser.lvh * 0.15} top`,
      scrub: true,
      // markers: true,
    },
  })

  tl.add("start")
  tl.fromTo(refPreheading.value, { opacity: 0 }, { opacity: 1 }, "start")
  refHeading.value.animateIn({ tl, label: "start" })

  tl.fromTo(
    refLogo.value,
    { opacity: 0, x: "-10%" },
    { opacity: 1, x: 0 },
    "start"
  )

  return tl
})

const { init: initParallax } = useScrollTrigger(() => {
  let tl = $gsap.timeline({
    scrollTrigger: {
      id: "sticky-base-panel",
      // trigger: refRoot.value,
      trigger: props.trigger,
      // start: "top top",
      start: () => `top+=${browser.lvh * (env.isMobile ? 0.25 : 0.4)} top`,
      end: () => `top+=${browser.lvh * (env.isMobile ? 0.5 : 0.7)} top`,
      scrub: true,
      // markers: true,
    },
  })

  // let innerRect = refInner.value.getBoundingClientRect()
  // let diff = (window.innerHeight - innerRect.height) * 0.5

  tl.add("start")
  // tl.to(
  //   refInner.value,
  //   {
  //     y: -diff,
  //     ease: "none",
  //   },
  //   "start"
  // )
  tl.fromTo(refInner.value, { opacity: 1 }, { opacity: 0 }, "start")
  tl.fromTo(refLogo.value, { opacity: 1 }, { opacity: 0, scale: 0.95 }, "start")

  return tl
})

const init = function () {
  initIn()
  initParallax()
}

onMounted(init)
useResize2(init)
watch(() => props.trigger, init)

const onLoaded = function () {
  init()
}
</script>

<style lang="scss" scoped>
@import "@/styles/shared.scss";

.sticky-base-panel {
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100lvh;
  @include flex(column);
  color: black;
  // background: white;
}

.the-container {
  position: relative;
}

.the-col {
  grid-column: 1 / span 8;
  padding-block: $p5;
}

.heading {
  margin-top: $p1;
}

.logo-container {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;

  .the-grid {
    height: 100%;
  }

  .logo-col {
    grid-column: 6 / span 6;
    height: 100%;
    @include flex(column);

    .logo {
      fill: none;
      width: 100%;
      height: 80%;
      object-fit: contain;
    }
  }
}
</style>
